import Abstract from "../../abstract-view/abstract.js";

export default class Gallery extends Abstract {
  constructor(element) {
    super();

    this._element = element;
  }

  getLinksSelector() {
    return `.${this._element.classList[0]} a`;
  }

  getSlides() {
    return this._element.querySelectorAll(`.glide__slide`);
  }
}
